import React from 'react';
import { GIFTING_SHIPPING_BANNER_COPY } from './giftingCategoryMenuConstants';
import bannerStyles from './GiftingCategoryShippingBannerBrandRefresh.module.css';

const giftToFromSticker = require('./imgs/gift-to-from-sticker.png');

function GiftingCategoryShippingBannerBrandRefresh() {
  const { title, body } = GIFTING_SHIPPING_BANNER_COPY;

  return (
    <div className={bannerStyles.banner} data-part="shipping-banner">
      <div className={bannerStyles.copy} data-part="shipping-banner-copy">
        <h3 className={bannerStyles.title} data-part="shipping-banner-title">
          {title}
        </h3>
        <p className={bannerStyles.body} data-part="shipping-banner-body">
          {body}
        </p>
      </div>
      <div className={bannerStyles.stickerStack} aria-hidden="true">
        <div
          className={`${bannerStyles.stickerFrame} ${bannerStyles.stickerBackFrame}`}
        >
          <img src={giftToFromSticker} alt="" className={bannerStyles.stickerImg} />
        </div>
        <div
          className={`${bannerStyles.stickerFrame} ${bannerStyles.stickerFrontFrame}`}
        >
          <img src={giftToFromSticker} alt="" className={bannerStyles.stickerImg} />
        </div>
      </div>
    </div>
  );
}

export default GiftingCategoryShippingBannerBrandRefresh;
